import { Dialog, Transition } from '@headlessui/react'
import { type ComponentChildren, Fragment } from 'preact'
import type { MutableRefObject } from 'react-dom'
import * as styles from './modal.module.css'

export function ModalCloseButton({ onClick }: { onClick: () => void }) {
  return (
    <button type='button' class={styles.closeButton} onClick={onClick}>
      <i class='ion-close-round' />
    </button>
  )
}

export function ModalPanel({
  children,
  className
}: {
  children: ComponentChildren
  className?: string
}) {
  return <div className={className || styles.dialogPanel}>{children}</div>
}

/**
 * Note: this component's markup is structured in a way that an "outside click"
 * does **not** close the modal. This is a workaround, because headlessui does
 * not currently support disabling the outside click behavior.
 */
export function Modal({
  isOpen,
  onClose,
  children,
  initialFocus
}: {
  isOpen: boolean
  onClose: () => void
  children: ComponentChildren
  initialFocus?: MutableRefObject<HTMLElement | null>
}) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as='div'
        onClose={onClose}
        className={styles.dialog}
        initialFocus={initialFocus}
      >
        <Transition.Child
          as={Fragment}
          enter={styles.backdropEnter}
          enterFrom={styles.backdropEnterFrom}
          enterTo={styles.backdropEnterTo}
          leave={styles.backdropLeave}
          leaveFrom={styles.backdropLeaveFrom}
          leaveTo={styles.backdropLeaveTo}
        >
          <div className={styles.backdrop} aria-hidden='true' />
        </Transition.Child>
        <Transition.Child
          as={Fragment}
          enter={styles.panelEnter}
          enterFrom={styles.panelEnterFrom}
          enterTo={styles.panelEnterTo}
          leave={styles.panelLeave}
          leaveFrom={styles.panelLeaveFrom}
          leaveTo={styles.panelLeaveTo}
        >
          <Dialog.Panel className={styles.wrapper}>{children}</Dialog.Panel>
        </Transition.Child>
      </Dialog>
    </Transition>
  )
}
